import React from 'react';
import { Link } from 'react-router-dom';
import SectionLabel from './SectionLabel';
import Reveal from './Reveal';
import { ArrowRight } from 'lucide-react';
import { useI18n } from '../i18n/I18nContext';

export default function ProcessSteps() {
  const { t } = useI18n();
  const steps = t('process.steps') || [];
  return (
    <section className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="space-y-5 max-w-2xl">
            <SectionLabel>{t('process.tag')}</SectionLabel>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold text-slate-900 leading-[1.05]">
              {t('process.title_a')} <span className="text-gradient-green">{t('process.title_b')}</span>
            </h2>
          </div>
          <Link to="/services" className="inline-flex items-center gap-2 text-sm text-blue-600 hover:text-blue-500 transition-colors">
            {t('common.learn_more')} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {steps.map((step, i) => (
            <Reveal key={step.title} delay={i * 40}>
              <div className="group relative h-full rounded-2xl border border-blue-500/10 bg-white p-7 hover:border-blue-500/30 hover:bg-slate-50 transition-all overflow-hidden">
                <span className="absolute top-0 left-0 h-px w-0 bg-gradient-to-r from-transparent via-blue-500 to-transparent group-hover:w-full transition-all duration-700" />
                <div className="flex items-baseline justify-between mb-5">
                  <span className="font-mono text-xs tracking-widest text-blue-600">{String(i + 1).padStart(2, '0')}</span>
                  <span className="h-1.5 w-1.5 rounded-full bg-blue-500/60 group-hover:bg-blue-500 group-hover:shadow-[0_0_12px_rgba(37,99,235,0.9)] transition-all" />
                </div>
                <h3 className="font-display text-xl font-medium text-slate-900 mb-3 leading-snug">{step.title}</h3>
                <p className="text-sm text-slate-700/70 leading-relaxed">{step.desc}</p>
              </div>
            </Reveal>
          ))}
          <Reveal delay={steps.length * 40}>
            <Link to="/services" className="group relative h-full flex flex-col justify-between rounded-2xl border border-blue-500/25 bg-gradient-to-br from-blue-50 via-white to-white p-7 hover:from-blue-100 transition-all overflow-hidden">
              <div>
                <span className="font-mono text-xs tracking-widest text-blue-600">→</span>
                <h3 className="font-display text-xl font-medium text-slate-900 mt-5">{t('process.cta_cell_title')}</h3>
              </div>
              <div className="mt-8 flex items-center gap-2 text-blue-600 text-sm">
                {t('common.learn_more')} <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
